import { CatalogCta, CatalogHero, CatalogLayout } from "../components/catalog";

export function IntegrationPage() {
  return (
    <CatalogLayout
      title="Integration & Documentation"
      description="Plan device, data, algorithm and robot runtime integration with explicit interfaces and versioned validation."
    >
      <CatalogHero
        label="Resources"
        title="Integration & Documentation"
        intro="Connect your devices, data standards and compute environment. Start with a representative sample and define the interfaces, versions and validation needed for your workflow."
      />
      <section className="catalog-wrap catalog-section catalog-first">
        <div className="catalog-features catalog-four">
          {[
            [
              "Device integration",
              "Provide hardware model, firmware, protocol, timestamp definitions, sample rates and example recordings. Validate reading and clock alignment before pairing devices.",
            ],
            [
              "Dataset export",
              "Define the target model schema and action space, then test export. Deliver video, time series, calibration, annotations and a version manifest together.",
            ],
            [
              "Algorithms and APIs",
              "Agree on inputs, outputs, versions, retries and human review. Keep API keys server-side; third-party transfer of sensitive raw data requires specific authorization.",
            ],
            [
              "Training and deployment",
              "Specify dependencies, model licenses, compute and runtime. Check latency, action bounds, emergency stop and takeover before physical execution.",
            ],
          ].map(([e, t]) => (
            <article key={e}>
              <h3>{e}</h3>
              <p>{t}</p>
            </article>
          ))}
        </div>
      </section>
      <section className="catalog-band">
        <div className="catalog-wrap catalog-section">
          <h2>Validate the full path with one sample.</h2>
          <div className="catalog-features catalog-four">
            {[
              ["Share a sample", "One task, one complete episode and the actual device version."],
              [
                "Check the data contract",
                "Verify clocks, units, coordinate frames, state and action fields.",
              ],
              ["Run integration checks", "Read, replay and export; document unsupported fields."],
              ["Freeze the release", "Deliver adapter notes, test results and maintenance scope."],
            ].map(([e, t]) => (
              <article key={e}>
                <h3>{e}</h3>
                <p>{t}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
      <section className="catalog-wrap catalog-section">
        <h2>An open ecosystem with explicit compatibility.</h2>
        <p className="catalog-section-intro">
          LeRobot, ROS 2 and multimodal logging tools can be integration targets. Test the actual device,
          format and version; this does not imply universal compatibility or an official partnership.
        </p>
        <div className="catalog-two">
          <article>
            <h3>LeRobot</h3>
            <p>Robot learning data and training workflows.</p>
            <a
              className="catalog-text-link"
              href="https://huggingface.co/docs/lerobot/index"
              target="_blank"
              rel="noopener noreferrer"
            >
              Official documentation →
            </a>
          </article>
          <article>
            <h3>Foxglove</h3>
            <p>Robot logs and multimodal data visualization.</p>
            <a
              className="catalog-text-link"
              href="https://docs.foxglove.dev/docs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Official documentation →
            </a>
          </article>
        </div>
        <div className="catalog-callout">
          <h3>SDKs, sample data and interface lists</h3>
          <p>
            Share the target device, operating system and model environment so we can confirm available
            documentation, software versions, license terms and integration work.
          </p>
        </div>
      </section>
      <CatalogCta />
    </CatalogLayout>
  );
}
